import { Box } from '@mui/material';
import React from 'react';
import Images from '../../../Configs/images';

export default function Dev(props) {
  const { message } = props;
  return (
    <Box display="flex" gap={1} alignItems="flex-start" bgcolor="#D9EDFC" p={1} borderRadius={1} fontSize={12} {...props}>
      <img src={Images.Info} alt="info" />
      <div>
        {message}
      </div>
    </Box>
  );
}
